// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  hmr: false,
  gqlLink: 'https://gqldev.spekwo.com/graphql',
  website: 'https://www.dev.spekwo.com/',
  displayWebsite: 'www.dev.spekwo.com',
  email: 'hello@spekwo.com',
  apiHost: 'https://dev.api.spekwo.com/',
  customerUrl: 'https://dev.client.spekwo.com/',
  displayCusUrl: 'dev.client.spekwo.com '
};



// WEBPACK FOOTER //
// /vercel/path0/src/environments/environment.ts